import script from "./MessageQuote.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageQuote.vue?vue&type=script&setup=true&lang=ts"

import "./MessageQuote.vue?vue&type=style&index=0&id=313aeae0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-313aeae0"]])

export default __exports__